module.exports = __webpack_public_path__ + "img/examples-ru-5.3688c347.jpg";